import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'zipCodeMask',
  standalone: true,
})
export class ZipCodeMaskPipe implements PipeTransform {
  transform(value: string | number | null | undefined): string {
    if (value === null || value === undefined) return '--';

    const digits = String(value).replace(/\D/g, '');
    if (!digits) return '--';

    if (digits.length > 5) {
      return `${digits.slice(0, 5)}-${digits.slice(5, 9)}`;
    }

    return digits;
  }
}
